import { useRef, useEffect, useCallback } from 'react';

const useEventEndHandler = (callback, timeout = 100) => {
  const timeoutID = useRef(null);
  useEffect(() => {
    return () => {
      window.clearTimeout(timeoutID.current);
    };
  }, []);
  const debouncedCallback = useCallback(() => {
    window.clearTimeout(timeoutID.current);
    timeoutID.current = window.setTimeout(callback, timeout);
  }, [callback, timeout]);
  return debouncedCallback;
};

export default useEventEndHandler;
